import React, { useEffect, useState } from "react";
import Logo from "@/components/Logo";
import { Menu, X } from "lucide-react";

const APP_URL = "https://app.fittrackcoach.in";

const NAV_LINKS = [
  { label: "Why switch", href: "#why-coaches" },
  { label: "Features", href: "#features" },
  { label: "Pricing", href: "#pricing" },
  { label: "FAQ", href: "#faq" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#050814]/80 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent border-b border-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="section-container flex items-center justify-between h-20 md:h-24">
        <a href="#top" className="flex items-center" data-testid="header-logo-link">
          <Logo height={60} />
        </a>

        <nav className="hidden md:flex items-center gap-8" aria-label="Primary">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm text-white/70 hover:text-white transition-colors font-medium"
              data-testid={`nav-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href={APP_URL}
            className="text-sm text-white/80 hover:text-white px-3 py-2 font-medium transition-colors"
            data-testid="header-signin-link"
          >
            Sign in
          </a>
          <a
            href={APP_URL}
            className="btn-primary-glow rounded-xl px-5 py-2.5 text-sm inline-flex items-center gap-2"
            data-testid="header-cta"
          >
            Start Free
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>
            </svg>
          </a>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          className="md:hidden p-2 text-white"
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden bg-[#050814]/95 backdrop-blur-xl border-t border-white/5" data-testid="mobile-menu">
          <div className="section-container py-5 flex flex-col gap-1">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="py-3 text-white/80 hover:text-white border-b border-white/5"
                data-testid={`mobile-nav-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {link.label}
              </a>
            ))}
            <a
              href={APP_URL}
              className="btn-primary-glow rounded-xl px-5 py-3 mt-4 text-center font-bold"
              data-testid="mobile-cta"
            >
              Start Free — Setup in 2 Minutes
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
